export const Landing = '/';
export const About = '/about';
export const Work = '/work';
